let _ = require('../_.js');
var $ = jQuery;

// This is an attempt to make an ajax wrapper that lets the server communicate errors in the response in
// a well defined way.  The way the server returns messages is inconsistent right now and should be cleaned up.

// Todo: Retry on failure
// Todo: add session tokens if available
// Todo: parse response for changed data records and update immediatly
_.get_deployment_key = function () {
    if (!_.__deployment_key) {
        if ($("#deployment_key").length) {
            _.__deployment_key = $("#deployment_key").val();
        } else {
            _.__deployment_key = '';
        }
    }

    return _.__deployment_key;
}

// Interface to jquery ajax.
//
// While making an ajax request, this blocks realtime updates.
// 
// The request includes the deployment key, and the response is checked
// for errors and _modified realtime update data.

// _.ajax = async function (options) {
//     return new Promise(function (resolve, reject) {
//         // Prevents realtime updates while we are submitting an ajax request.
//         _.mutex('_core_realtime', async function () {
//             try {
//                 let result = await _.ajax(options);
//                 resolve(result);
//             } catch (e) {
//                 reject(e);
//             }
//         });
//     });
// }

_.ajax_retryable = async function (options) {
    if (!options.data) {
        options.data = {};
    }

    options.data.retryable = true;

    return await _.ajax(options);
}
_.ajax = function (options) {
    const startTime = Date.now();
    const maxDuration = 180000; // 3 minutes in milliseconds
    let retryAttempt = 0;
    // Exponential backoff with full jitter (1 s doubling to 30 s), or the server's Retry-After.
    // A fixed delay synchronizes every client's retries into waves against a struggling server.
    const nextRetryDelay = function (xhr) {
        let retryAfter = xhr && xhr.getResponseHeader ? parseInt(xhr.getResponseHeader('Retry-After')) : NaN;
        retryAttempt++;
        if (retryAfter > 0) {
            return retryAfter * 1000;
        }
        return Math.random() * Math.min(30000, 1000 * Math.pow(2, retryAttempt));
    };

    // Initialize data if not present
    if (!options.data) {
        options.data = {};
    }

    // Add deployment key
    options.data.deployment_key = _.get_deployment_key();

    // Convert boolean to 1/0 for specific fields
    for (let key in options.data) {
        if (options.data.hasOwnProperty(key) && typeof options.data[key] === 'boolean') {
            options.data[key] = options.data[key] ? 1 : 0;
        }
    }

    // Append URL prefix if exists
    if (options.url && _.ajax_url_prefix) {
        options.url = _.ajax_url_prefix + options.url;
    }

    // Check if retry is enabled for this call, this works with 'priorityproxy'
    let isRetryable = options.data.retryable;
    if (isRetryable) {
        delete options.data.retryable;
        if (options.url.indexOf('?') == -1) {
            options.url += '?';
        } else {
            options.url += '&';
        }
        options.url += '__r=1';
    }

    function makeRequest(resolve, reject) {
        options.success = function (response) {
            // Debug and ORM updates handling
            if (response && response.debug) {
                console.log("API: " + options.url, options.data, " Debug: ", response.debug);
            }

            // Retry logic for retryable response (__retry = true)
            if (isRetryable && response && response.__retry) {
                let elapsedTime = Date.now() - startTime;
                if (elapsedTime < maxDuration) {
                    let delay = nextRetryDelay(null);
                    console.log(`Retrying in ${Math.round(delay / 1000)} seconds...`);
                    setTimeout(() => makeRequest(resolve, reject), delay);
                } else {
                    reject(new Error("Request failed after 3 minutes of retrying."));
                }
            } else {
                if (response && response._modified) {
                    response._modified.forEach(rd => {
                        _.__update_data_record_from_ajax_response(rd[0], rd[1], rd[3], 'hybrid');
                    });
                }

                // Success response handling
                if (response && (response.success === true || response.success === "true")) {
                    resolve(response.return);
                } else if (response && response.errors) {
                    reject(response.errors);
                } else if (response && response.error) {
                    reject(response.error);
                } else if (response && (response.success === false || response.success === "false")) {
                    reject(response.return);
                } else {
                    resolve(response);
                }
            }
        };
        options.error = function (xhr, status, error) {
            // Retry on server errors if retryable
            if (isRetryable && xhr.status >= 500) {
                let elapsedTime = Date.now() - startTime;
                if (elapsedTime < maxDuration) {
                    let delay = nextRetryDelay(xhr);
                    console.log(`Retrying in ${Math.round(delay / 1000)} seconds after server error...`);
                    setTimeout(() => makeRequest(resolve, reject), delay);
                } else {
                    reject(new Error("Request failed after 3 minutes of retrying due to server errors."));
                }
            } else {
                // Provide structured error information
                let structuredError = {
                    status: xhr.status,
                    statusText: xhr.statusText,
                    responseText: xhr.responseText,
                    responseJSON: xhr.responseJSON,
                    error: error,
                    message: status === 'error' && xhr.status === 0
                        ? 'Network connection error'
                        : (xhr.statusText || error || 'Unknown error')
                };
                reject(structuredError);
            }
        };

        $.ajax(options);
    }

    return new Promise(makeRequest);
}


